export default __webpack_public_path__ + "e9bb776e767c9e3454acf2eb850ff14f.gif";